/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var DataRefreshResponseType;
(function (DataRefreshResponseType) {
    DataRefreshResponseType["SLUG_LEVEL"] = "Slug Level";
    DataRefreshResponseType["EVERYTHING"] = "Everything";
    DataRefreshResponseType["COUNTS_ONLY"] = "Counts Only";
    DataRefreshResponseType["UE_REPORTS_ONLY"] = "UE Reports Only";
})(DataRefreshResponseType || (DataRefreshResponseType = {}));
